<template>

  <div class="bg-primary text-center  p-5">
    <p class="bg-white shadow shadow-3 text-center p-3  border-3"><slot></slot></p>

    <img class="img-fluid bg-primary d-none d-lg-block d-xl-block  d-md-none d-sm-none d-xs-none ml-auto mr-auto"  :src="img"  alt="">
    <img class="img-fluid bg-primary d-lg-none d-xl-none d-md-block d-sm-block ml-auto mr-auto " :src="img_mobile" alt="">
  </div>



</template>

<script>
export default {
  name: "S400",
  props:{
    img:{
      default:"https://picsum.photos/200/300"
    },
    img_mobile:{
      default:"https://picsum.photos/id/237/200/300"
    }


  }

};
</script>

<style scoped>

</style>